export default "/images/logo.png?a35bd0be5a1b081d4ceeda95ed9026e8";